import moment from "moment";

export const untimezonedMoment = (
  val: moment.MomentInput,
  format?: moment.MomentFormatSpecification
) => {
  const parsed = moment.parseZone(val, format).format("YYYY-MM-DDTHH:mm:ss");
  return moment(parsed);
};
